export default __webpack_public_path__ + "static/media/reseller.0a419a84.svg";